var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({class:_vm.$s.BladeContainer,style:(_vm.style),attrs:{"aria-labelledby":_vm.ariaLabelledby}},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{class:_vm.$s.Blade},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }